// extracted by mini-css-extract-plugin
export default {"signBox":"styles_signBox__n4In5","animate":"styles_animate__wsOJP","startWizard":"styles_startWizard__+uh0N"};